import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnDestroy, OnInit, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { ActivatedRoute } from '@angular/router';
import { map, combineLatest, Observable } from 'rxjs';
import { ConfirmDialogComponent, DEFAULT_SNACKBAR_CONFIG, Logger, OrganizationService, PreviewMode, UtilityService } from 'src/app/@shared';
import { MontageBuilderService, OfferProductService, Product, ProductDomain } from '../..';

import { AuthorizeControlService } from 'pr1-ui-components';
import { MatTableDataSource } from '@angular/material/table';
import { AssetsListService } from '../../services/assets-list.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';

const log = new Logger('OfferProductsCardsComponent');

@Component({
  selector: 'app-offer-products-cards',
  templateUrl: './offer-products-cards.component.html',
  styleUrls: ['./offer-products-cards.component.scss'],
})

export class OfferProductsCardsComponent<T extends Product> implements OnInit, OnDestroy, AfterViewInit {
  viewModel$ = combineLatest([
    this.offerProductService.products$,
    this.offerProductService.isLoading$,
    this.offerProductService.totalRecords$,
    this.offerProductService.page$,
  ]).pipe(
    map(([products, isLoading, totalRecords, page]) => {
      if (products.length == 0 && page.pageIndex > 0) {
        this.offerProductService.resetpage();
        this.offerProductService.reload();
      }
      const preselectedProducts = products.filter(product => product.IsFeaturedProduct);
      this.montageBuilderService.preSelectedProductsBehaviourSubject.next(preselectedProducts);
      return { products, isLoading, totalRecords, page }
    }),
  );
  PreviewMode = PreviewMode;
  productsList: MatTableDataSource<ProductDomain<T>> = new MatTableDataSource();
  selection = new SelectionModel<ProductDomain<T>>(true, [], true, (o1, o2) => o1.DomainId === o2.DomainId);
  selectedProducts: any[] = [];
  constructor(
    private offerProductService: OfferProductService<T>,
    public utilityService: UtilityService,
    private route: ActivatedRoute,
    private organizationService: OrganizationService,
    private authorizationService: AuthorizeControlService,
    private montageBuilderService: MontageBuilderService,
    private cdr: ChangeDetectorRef, // <-- Inject ChangeDetectorRef
    private assetsListService: AssetsListService,
    private matSnackBar: MatSnackBar,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    log.debug('init');
    this.offerProductService.offerId = this.route.snapshot.params['offerId'];
    this.offerProductService.products$.subscribe((data) => {
      this.productsList = new MatTableDataSource(data);
    });
    // Remove selection logic from here
    this.selection.changed.subscribe(() => {
      this.montageBuilderService.selectedOfferProductsBehaviorSubject.next(this.selection.selected);
    });
  }

  ngAfterViewInit(): void {
    // Move selection logic here and trigger change detection
    const selectedProducts = this.montageBuilderService.selectedOfferProductsBehaviorSubject.value;
    if (selectedProducts && selectedProducts.length > 0) {
      this.selection.select(...selectedProducts);
      this.cdr.detectChanges();
    }
  }

  ngOnDestroy() { }
  getSelected(selectedProduct: any) {
    this.selectedProducts.push(selectedProduct);
  }
  onSort(sortState: Sort): void {
    this.offerProductService.sort(sortState);
  }

  onPage(pageEvent: PageEvent): void {
    this.selection.clear();
    this.offerProductService.page(pageEvent);
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.productsList.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.productsList.data.forEach(row => this.selection.select(row));
  }

  public getSelectedSectionRecords() {
    return this.selection.selected;
  }

  public clearSelection() {
    this.selection.clear();
  }

  isAdmin(): boolean {
    const hasAccess = this.authorizationService.checkAccess('admin||offermang');
    return hasAccess;
  }

  onImageError(event: Event): void {
    const element = event.target as HTMLImageElement;
    element.src = './assets/images/default-image.png'; // Path to your default image
  }

  onFeaturedChange(checked: boolean, product: ProductDomain<T>) {
    const previousValue = product.IsFeaturedProduct;
    product.IsFeaturedProduct = checked;
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Confirm Featured',
        message: `Are you sure you want to make this product ${checked ? 'featured' : 'unfeatured'}?`,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.assetsListService.updateIsFeaturedProduct('OFFER', this.route.snapshot.params['offerId'], product.DomainId, checked).subscribe({
          next: () => {
            this.matSnackBar.open(`${product.Detail.ProductName} featured status updated`, 'OK', DEFAULT_SNACKBAR_CONFIG);
          },
          error: (error) => {
            product.IsFeaturedProduct = previousValue;
            console.error('Error updating product featured status', error);
          }
        });
      } else {
        product.IsFeaturedProduct = previousValue;
      }
    });
  }

}
